import React from "react";
import SuccesfulOrderPlacementComponent from "../../components/SuccesfulOrderPlacementComponent.tsx";
import { useParams } from "react-router-dom";

const OrderResultPage = () => {
  const { status } = useParams();

  if (status === "succes") {
    return <SuccesfulOrderPlacementComponent isSucces={true} />;
  } else if (status === "failed") {
    return <SuccesfulOrderPlacementComponent isSucces={false} />;
  }

  return <SuccesfulOrderPlacementComponent />;
};

export default OrderResultPage;
